type SuccessPayload<TPayload extends {success: boolean, error: boolean, data: unknown}> = Extract<
    TPayload,
    {success: true}
>['data'];

export const getSuccessPayload = <TPayload extends {success: boolean, error: boolean, data: unknown}>(
    payload: TPayload,
) => (
    payload.success ? (payload.data as SuccessPayload<TPayload>) : null
);
